import { router } from './Routes/routes'
import { RouterProvider } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import CustomCursor from './components/CustomCursor'
import './App.css'

function App() {
  return (
    <div
      className='relative flex flex-col items-center min-h-screen h-full'
      style={{ background: '#07070f' }}
    >
      {/* ── atmospheric background ── */}
      <div style={{ position: 'fixed', inset: 0, zIndex: 0, overflow: 'hidden', pointerEvents: 'none' }}>

        {/* top-center warm spotlight */}
        <div style={{
          position: 'absolute', top: '-25%', left: '50%', transform: 'translateX(-50%)',
          width: '80vw', height: '60vw', borderRadius: '50%',
          background: 'radial-gradient(ellipse, rgba(250,204,21,0.06) 0%, transparent 60%)',
          animation: 'float3 18s ease-in-out infinite',
        }} />

        {/* gold orb — top-left */}
        <div style={{
          position: 'absolute', top: '-10%', left: '-5%',
          width: '52vw', height: '52vw', borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(250,204,21,0.13) 0%, transparent 60%)',
          animation: 'float1 16s ease-in-out infinite',
        }} />

        {/* deep blue orb — bottom-right */}
        <div style={{
          position: 'absolute', bottom: '-15%', right: '-5%',
          width: '48vw', height: '48vw', borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(79,70,229,0.12) 0%, transparent 60%)',
          animation: 'float2 20s ease-in-out infinite',
        }} />

        {/* teal accent — left mid */}
        <div style={{
          position: 'absolute', top: '45%', left: '-8%',
          width: '28vw', height: '28vw', borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(20,184,166,0.06) 0%, transparent 65%)',
          animation: 'float3 13s ease-in-out infinite',
        }} />

        {/* grid mesh */}
        <div style={{
          position: 'absolute', inset: 0,
          backgroundImage: `
            linear-gradient(rgba(250,204,21,0.032) 1px, transparent 1px),
            linear-gradient(90deg, rgba(250,204,21,0.032) 1px, transparent 1px)
          `,
          backgroundSize: '60px 60px',
        }} />

        {/* bottom vignette */}
        <div style={{
          position: 'absolute', inset: 0,
          background: 'radial-gradient(ellipse 80% 60% at 50% 100%, rgba(7,7,15,0.9) 0%, transparent 70%)',
        }} />
      </div>

      <CustomCursor />
      <RouterProvider router={router} />
      <Toaster
        toastOptions={{
          style: {
            background: 'rgba(10,10,20,0.95)',
            color: '#facc15',
            border: '1px solid rgba(250,204,21,0.22)',
            backdropFilter: 'blur(16px)',
            fontFamily: 'Space Grotesk, sans-serif',
            fontSize: '13px',
          },
        }}
      />
    </div>
  )
}

export default App
